import type { JSONValue } from '@ai-sdk/ui-utils';
import type { ThinkingAnnotation, WiredThinkingAnnotation } from '~/types/thinking';

export function serializeThinkingAnnotation(annotation: Omit<ThinkingAnnotation, 'type'>): WiredThinkingAnnotation {
  return {
    t: 'thinking',
    c: annotation.content ?? '',
    d: annotation.done ? 1 : 0,
  };
}

export function deserializeThinkingAnnotation(annotation: WiredThinkingAnnotation): ThinkingAnnotation {
  return {
    type: 'thinking',
    content: annotation.c,
    done: Boolean(annotation.d),
  };
}

export function isThinkingAnnotation(annotation: JSONValue): annotation is WiredThinkingAnnotation {
  return (
    annotation !== undefined &&
    annotation !== null &&
    typeof annotation === 'object' &&
    't' in annotation &&
    annotation.t === 'thinking'
  );
}
